export const TIMELINE_DAY_MS = 24 * 60 * 60 * 1000;

export interface TimelineTaskTimeSource {
  created_at?: number;
  due_time?: number;
  end_time?: number;
  status: string;
}

export interface TaskTimelineRange {
  start: number;
  end: number;
  estimated: boolean;
}

export interface TimelineBounds {
  start: number;
  end: number;
}

export function getTaskTimelineRange(
  task: TimelineTaskTimeSource
): TaskTimelineRange {
  const start = Number(task.created_at) || Date.now();
  const hasActualEnd = task.status === "done" && Number(task.end_time) > 0;
  const candidateEnd = hasActualEnd ? Number(task.end_time) : Number(task.due_time);
  return {
    start,
    end: candidateEnd > start ? candidateEnd : start + TIMELINE_DAY_MS,
    estimated: !hasActualEnd,
  };
}

export function getTimelineBounds(ranges: TaskTimelineRange[]): TimelineBounds {
  if (!ranges.length) {
    const now = Date.now();
    return { start: now - TIMELINE_DAY_MS, end: now + TIMELINE_DAY_MS };
  }
  return {
    start: Math.min(...ranges.map((range) => range.start)) - TIMELINE_DAY_MS,
    end: Math.max(...ranges.map((range) => range.end)) + TIMELINE_DAY_MS,
  };
}

export function getTimelinePosition(
  timestamp: number,
  bounds: TimelineBounds
): number {
  const duration = Math.max(bounds.end - bounds.start, 1);
  return ((timestamp - bounds.start) / duration) * 100;
}
